import { Controller } from "stimulus";

// Payer profile section descriptions: collapsed by default, toggled by the ⓘ
// in the section header, with the reader's choice remembered per section.
// Opening/closing slides via CSS (see css/section_description.css).
export default class extends Controller {
  static targets = ["toggle"];

  static values = { key: String };

  connect() {
    this.setExpanded(this.read() === "expanded");

    // Enable the transition only after the remembered state is applied, so a
    // reopened section doesn't animate on page load.
    requestAnimationFrame(() => this.element.classList.add("section-description-animated"));
  }

  toggle() {
    const expanded = !this.expanded;

    this.setExpanded(expanded);
    this.store(expanded ? "expanded" : "collapsed");
  }

  setExpanded(expanded) {
    this.element.classList.toggle("section-description-expanded", expanded);
    this.toggleTargets.forEach(t => t.setAttribute("aria-expanded", expanded));
  }

  get expanded() {
    return this.element.classList.contains("section-description-expanded");
  }

  // Same key format the collapsible controller used, so readers' earlier
  // open/closed choices carry over.
  get storageKey() {
    return `collapsible:${this.keyValue}`;
  }

  store(state) {
    try {
      localStorage.setItem(this.storageKey, state);
    } catch (_) {
      // Storage blocked (e.g. private mode); the toggle still works for this page view
    }
  }

  read() {
    try {
      return localStorage.getItem(this.storageKey);
    } catch (_) {
      return null;
    }
  }
}
